<template>
  <div class="main-content">
    <ValidationObserver ref="observer">
      <div class="main-content__csv-box">
        <div class="form-group">
          <label>Time sheet csv file</label>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <FileInput v-model="csv" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>

        <div class="d-flex justify-content-center mt-5">
          <b-button pill variant="primary" @click="confirm">
            Import
          </b-button>
        </div>
        <ErrorCsv :errorMessages="error" />
      </div>

    </ValidationObserver>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { readCsv, countRecords } from '@/utils/csv'
import FileInput from '@/components/parts/inputItem/FileInput.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import ErrorCsv from '@/components/parts/ErrorCsv.vue'

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FileInput,
    Loading,
    ErrorCsv,
  },
})
export default class TimesheetUploadOthers extends Vue {
  private csv: File|null = null

  private error: string[]|string|Object|null = null

  private isLoading: boolean = false

  private async confirm() {
    const isOk: boolean = await (this.$refs.observer as any).validate()
    if (isOk !== true) {
      return
    }

    try {
      const reader = await readCsv(this.csv as File)
      const recordsCount = countRecords(reader)
      const isConfirmed = await this.$bvModal.msgBoxConfirm(`Import ${recordsCount} schedules. Is it OK?`)

      if (isConfirmed === true) {
        this.uploadCsv()
      }
    } catch (error) {
      this.error = 'selected file has error. please select file again.'
      this.csv = null
    }
  }

  private async uploadCsv() {
    if (this.isLoading) {
      return
    }

    this.isLoading = true
    try {
      await this.$store.dispatch('importSchedulesCsv', this.csv)
      this.isLoading = false
      this.$bvModal.msgBoxOk('Success !')
    } catch (error: any) {
      this.isLoading = false
      this.error = error
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}
</style>
